import React from 'react';
import './About.css'
const About = () => {
    return (
        <div className="py-5">
            <section>
                <div className="container">
                    <div className="row">
                       
                        <div className="col-md-12">
                            <h2 className="mx-auto text-center About-header my-4" >ABOUT US</h2>
                            <p className="AboutUS"> The wedding is a very important occasion for every person. We all want everything to be absolutely perfect. The demand for unique and different ideas for weddings have also increased. Of course, everybody wants their wedding to be the best of the year. Don’t worry, we have creative minds to help you in managing wedding celebrations in the best possible manner. One of such tasks is the wedding stage decoration. This is the part where you need expert advice. You cannot learn wedding decoration in just few weeks especially when you have many other important things to care about.</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;